import Dialog from "../../atoms/dialog";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Button, Box, Typography } from '@material-ui/core';


const DeleteConnectionAlert = (props) => {

    const { onClose, message } = props;


    const [open, setOpen] = useState(false)


    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (
        <Dialog
            title={"Delete"}
            open={true}
            handleClose={handleClose}
        >
            <Grid container direction={"row"} spacing={3} >

                <Grid item xs={12}>
                    <Typography> {message} </Typography>
                </Grid>

                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                    <Button color="primary" variant="outlined" style={{ marginLeft: 10 }} onClick={onClose}> CLOSE </Button>
                    <Button color="primary" variant="outlined" style={{ marginLeft: 10 }} onClick={onClose} disabled={true}> DELETE </Button>
                </Grid>

            </Grid>


        </Dialog >
    )
}

export default DeleteConnectionAlert